export class DeleteLeadsInput {
  leadsIds: string[];
  comments: string;

  constructor(leadsIds: string[], comment: string) {
    this.leadsIds = leadsIds;
    this.comments = comment;
  }
}
